import '@babel/polyfill';
import React from 'react';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './CommonsContainer';
import { MarkNotificationAsRead } from '../notifications/MarkNotificationAsRead';
import { IncompatibleBrowser } from '../incompatible-browser/IncompatibleBrowser';
import { GlobalModalesWizard } from '../modales/GlobalModalesWizard';
import { Footer } from '../../../footer/Footer';
import { MainContent } from './MainContent';
import { FetchUserWatchers } from '../../../watchers/components/fetch-user-watchers/FetchUserWatchers';
import '../../../cookies/handleCookiesPolicy';
import { StartOneSignal } from '../one-signal/StartOneSignal';
import { LightHeader } from '../../../header/light/LightHeader';
import { SearchHeader } from '../../../header/search/SearchHeader';
import { Navigation } from '../../../navigation/Navigation';

interface CustomWindow extends Window {
  // eslint-disable-next-line camelcase
  original_query?: {} | null;
}

declare let window: CustomWindow;

type Props = PropsFromRedux;

export class RawCommons extends React.Component<Props> {
  componentDidMount() {
    if (window.original_query !== undefined && window.original_query !== null) {
      this.props.autoSearch();
    }
  }

  render() {
    const {
      shouldDisplaySearch,
      searchFiltersOpen,
      isMarketingLayout,
      hasQuery,
      children,
    } = this.props;

    return (
      <>
        <div
          className={classNames({
            'body-with-search-types': hasQuery,
            'filters-open': searchFiltersOpen,
          })}
        >
          {isMarketingLayout && (
            <LightHeader source="nav">
              <Navigation />
            </LightHeader>
          )}
          {!isMarketingLayout && <SearchHeader />}

          <div className={isMarketingLayout ? 'marketing-content' : 'content'}>
            <MainContent shouldDisplaySearch={shouldDisplaySearch}>
              {children}
            </MainContent>
          </div>
        </div>

        <div id="popover-root" />
        <div data-react="cookies-banner" />

        <FetchUserWatchers />
        <MarkNotificationAsRead />
        <GlobalModalesWizard />
        <IncompatibleBrowser />
        <StartOneSignal />
        <Footer />
      </>
    );
  }
}

export const Commons = Connect(RawCommons);
